var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import Vue from 'vue';
import { Component, Prop, Watch, Ref } from 'vue-property-decorator';
import env from 'config/env.js';
import { Talent } from 'packages/talent/entities/Talent';
import { Job } from 'packages/v3/jobs/Job';
import { TalentFileService } from 'packages/talent/TalentFileService';
import { CompanyService } from 'packages/company/CompanyService';
import { FileSourceType } from 'packages/core/File';
import LoaderBox from 'common/UIToolKit/layout/LoaderBox.vue';
import Icon from 'common/UIToolKit/Icon.vue';
import EmptyState from 'ui/v1/EmptyState.vue';
import FileViewer from 'packages/core/FileViewer.vue';
import UiSecondaryButton from 'ui/v1/controls/UiSecondaryButton.vue';
import DateField from 'ui/v1/DateField.vue';
import { Getter, namespace } from 'vuex-class';
import DownloadHelper from 'common/support/DownloadHelper';
import { container } from 'tsyringe';
import { UploadsRepository } from 'packages/files/UploadsRepository';
import Thumbnail from 'ui/v1/file/Thumbnail.vue';
var jobsModule = namespace('jobs');
var companyModule = namespace('companyModule');
var TalentFileView = /** @class */ (function (_super) {
    __extends(TalentFileView, _super);
    function TalentFileView() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.fileService = new TalentFileService();
        _this.companyService = new CompanyService();
        _this.uploadRepo = container.resolve(UploadsRepository);
        _this.file = null;
        _this.loading = true;
        return _this;
    }
    Object.defineProperty(TalentFileView.prototype, "jobId", {
        get: function () {
            var _a, _b;
            return ((_b = (_a = this.job) === null || _a === void 0 ? void 0 : _a.id) === null || _b === void 0 ? void 0 : _b.toString()) || null;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(TalentFileView.prototype, "jobUrl", {
        get: function () {
            return this.job ? env.APPS.PRODUCT.URL + "jobs/" + this.jobId : null;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(TalentFileView.prototype, "talentUrl", {
        get: function () {
            return "" + env.APPS.CANDIDATE_POOL.URL + this.talent.id;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(TalentFileView.prototype, "uploader", {
        get: function () {
            var _this = this;
            var _a, _b;
            if (!((_a = this.users) === null || _a === void 0 ? void 0 : _a.length) || !this.file) {
                return;
            }
            if (this.file.source === FileSourceType.FORM) {
                return this.$t('talent_card.files.source.form');
            }
            var user = (_b = this.users) === null || _b === void 0 ? void 0 : _b.find(function (user) { return user.id === _this.file.uploaderId; });
            return (user) ? user.name : this.$t('common.removed_user');
        },
        enumerable: false,
        configurable: true
    });
    TalentFileView.prototype.downloadFile = function () {
        return DownloadHelper.downloadFile(this.file);
    };
    TalentFileView.prototype.openDeletionConfirmation = function () {
        var _this = this;
        this.deletionConfirmation.confirm()
            .then(function () {
            _this.deleteFile(_this.file.id);
            _this.$emit('file-deleted', _this.file.id);
        })
            // eslint-disable-next-line @typescript-eslint/no-empty-function
            .catch(function () {
        });
    };
    TalentFileView.prototype.deleteFile = function (fileId) {
        this.uploadRepo.deleteFile(fileId);
    };
    TalentFileView.prototype.mounted = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, , 3, 4]);
                        this.loadFile(this.$route.params.file);
                        if (!this.job.companyId) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.getUsersForCompany(this.job.companyId)];
                    case 1:
                        _a.sent();
                        _a.label = 2;
                    case 2: return [3 /*break*/, 4];
                    case 3:
                        this.loading = false;
                        return [7 /*endfinally*/];
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    TalentFileView.prototype.openInNewTab = function () {
        var route = this.$router.resolve({ name: 'FullscreenFileViewer', params: { id: this.file.id.toString() }, query: this.jobId ? { jobId: this.jobId } : null });
        window.open(route.href, '_blank');
    };
    TalentFileView.prototype.loadFile = function (fileId) {
        var _this = this;
        var _a;
        this.fileService.allFilesForTalent(this.talent.id, false, this.candidateIsolationEnabledOrNil ? (_a = this.job) === null || _a === void 0 ? void 0 : _a.id : null)
            .then(function (files) {
            if (!files || !files.length) {
                return;
            }
            _this.file = files.find(function (file) { return file.id === parseInt(fileId); });
            if (!_this.file) {
                _this.file = files[0];
                _this.$router.replace({ params: { file: _this.file.id.toString() } });
            }
        });
    };
    var _a, _b, _c;
    __decorate([
        Prop({ default: false }),
        __metadata("design:type", Boolean)
    ], TalentFileView.prototype, "isFullScreen", void 0);
    __decorate([
        Prop(),
        __metadata("design:type", typeof (_a = typeof Talent !== "undefined" && Talent) === "function" ? _a : Object)
    ], TalentFileView.prototype, "talent", void 0);
    __decorate([
        Ref(),
        __metadata("design:type", Object)
    ], TalentFileView.prototype, "deletionConfirmation", void 0);
    __decorate([
        Getter,
        __metadata("design:type", Boolean)
    ], TalentFileView.prototype, "candidateIsolationEnabledOrNil", void 0);
    __decorate([
        jobsModule.State('job'),
        __metadata("design:type", typeof (_b = typeof Job !== "undefined" && Job) === "function" ? _b : Object)
    ], TalentFileView.prototype, "job", void 0);
    __decorate([
        jobsModule.State('job'),
        __metadata("design:type", typeof (_c = typeof Job !== "undefined" && Job) === "function" ? _c : Object)
    ], TalentFileView.prototype, "currentJob", void 0);
    __decorate([
        companyModule.State,
        __metadata("design:type", Array)
    ], TalentFileView.prototype, "users", void 0);
    __decorate([
        companyModule.Action,
        __metadata("design:type", Function)
    ], TalentFileView.prototype, "getUsersForCompany", void 0);
    __decorate([
        Watch('$route.params.file'),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [String]),
        __metadata("design:returntype", void 0)
    ], TalentFileView.prototype, "loadFile", null);
    TalentFileView = __decorate([
        Component({
            components: {
                Thumbnail: Thumbnail,
                Icon: Icon,
                DateField: DateField,
                UiSecondaryButton: UiSecondaryButton,
                FileViewer: FileViewer,
                EmptyState: EmptyState,
                LoaderBox: LoaderBox,
            },
        })
    ], TalentFileView);
    return TalentFileView;
}(Vue));
export default TalentFileView;
